import { ButtonERP, SearchInput } from "@finanedi.es/storybook"
import SwitchButtons from "common/components/SwitchButtons"
import CatalogosItems from "features/Inventario/components/CatalogosItems"
import { catalogosSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import { getCatalogos } from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { debounce } from "lodash"
import { useCallback, useMemo, useState } from "react"
import { Grid, Menu } from "react-feather"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import "./catalogos.scss"

const GRID = "GRID"
const LIST = "LIST"

const switchButtons = [
  {
    Icon: Grid,
    id: GRID,
  },
  {
    Icon: Menu,
    id: LIST,
  },
]

const Catalogos = () => {
  const { t } = useTranslation()
  const [nombreCatalogo, setNombreCatalogo] = useState("")
  const gridView =
    localStorage.getItem("inventario_catalogos_defaultView") !== "LIST"
  const [showGridLayout, setShowGridLayout] = useState(gridView)
  const { catalogos, fetchingCatalogos } = useSelector(catalogosSelector)

  const history = useHistory()
  const dispatch = useDispatch()

  const handleFilterCatalogos = useCallback(
    (nombre: $TSMigrationFixMe) => {
      dispatch(getCatalogos(nombre))
    },
    [dispatch]
  )

  const debounceFilterCatalogos = useMemo(
    () => debounce((search) => handleFilterCatalogos(search), 300),
    [handleFilterCatalogos]
  )

  const handleOnChangeNombre = (nombre: string) => {
    setNombreCatalogo(nombre)
    debounceFilterCatalogos(nombre)
  }

  return (
    <div className='content-container'>
      <div className='pt-4 content-header'>
        <p className='tw-text-xl tw-font-normal tw-flex tw-items-center tw-text-nowrap'>
          {t("catalogos.title")} {!fetchingCatalogos && `(${catalogos.length})`}
        </p>

        <div className='tw-flex tw-items-center tw-gap-2'>
          <SearchInput
            placeholder={`${t("catalogos.placeholderSearch")}`}
            onChange={(ev: string) => {
              handleOnChangeNombre(ev)
            }}
            inputValue={nombreCatalogo}
            className='tw-mb-1 sm:tw-mb-0 sm:tw-mr-2 tw-h-10 tw-w-full sm:tw-w-72'
          />

          <ButtonERP
            label={`${t("catalogos.addCatalog")}`}
            onClick={() => history.push(ROUTES.CREAR_CATALOGO)}
            customize={{
              type: "secondary",
              size: "md",
            }}
          />

          <SwitchButtons
            className='ml-3'
            btns={switchButtons}
            onSelect={({ id }: { id: string }) => {
              setShowGridLayout(id === GRID)
              localStorage.setItem("inventario_catalogos_defaultView", id)
            }}
            selectedButtonID={showGridLayout ? "GRID" : "LIST"}
          />
        </div>
      </div>

      <CatalogosItems showCatalogosWithTable={!showGridLayout} />
    </div>
  )
}

export default Catalogos
